import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  GSGo: {
    reportType: 'Locations',
    locationId: '',
    stratCatId: '',
    yearId: '',
  },
  compareColumns: [],
  crDataRaw: [],
  showCategoryIds: {},
  searchString: '',
  reportOptionsGo: {
    categoryFilterId: '',
    stratFilterId: '',
    showCI: true,
    showWN: true,
    hideMissingDataRows: false,
  },
  flags: {
    loadingCRData: false,
    showReportBody: false,
    showReportOptions: false,
    generatingPdf: false,
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/CR/index.js